<template>
	<section class="sub-ibox-title ">
		<h3 class="fx fx-y-center">
			<div class="back" v-show="isShowBack">
				<a v-show="isClick" @click="handleCustomFun" class="icon-back"></a>
				<a v-show="!isClick" v-back-link class="icon-back"></a>
			</div>
			<!--<div v-show="isShowBack && isTitle" class="wx-name">{{publicInfo.public_name || '公众号操作'}}<span class="p-l-10">◆</span></div>-->
			<div class="fx fx-x-between fx-fill fx-y-center">
				<slot name="title"></slot>
				<slot name="operation"></slot>
			</div>
		</h3>
	</section>
</template>
<script>
	import { mapState } from 'vuex'
	export default {
		name:"sub-ibox-title",
		/*
		 * 接收父组件数据
		 */
		data() {
			return {
			}
		},
		props: {
			isShowBack: {
				type:Boolean,
				default: true,
			},
			isClick: {
				type:Boolean,
				default: false,
			},
			isTitle: {
				type:Boolean,
				default: true,
			}
		},
		mounted (){
//		    let publicInfo =	this.$getSessionStorage('PUBLIC_INFO')	
//		    	this.$store.commit('SET_PUBLIC_INFO',publicInfo)
		},
		/*
		 * 属性计算
		 */
		computed: {
			...mapState({
				publicInfo: state => state.adminMemberPublic.publicInfo
			})
		},
		methods: {
			handleCustomFun(){
				this.$emit('custom')
			}
		}
	}
</script>
<!-- 添加 scoped “范围”属性CSS限制这个组件只 -->
<style scoped lang="scss">
	@import "src/assets/css/common.scss";
	.sub-ibox-title {
		border: $color-border 1px solid;
		background: $color-white;
		padding-left: px-em(40px);
		border-radius: 2px 2px 0 0;
		.back{
			position: relative;
			a {
				font-size: px-em(36px);
				display: inline-block;
				cursor: pointer;
				padding: px-em(24px) px-em(20px) px-em(24px) 0;
				&:hover{
					color: $color-main;
				}
				&:active{
				}
			}
		}
		p {
			font-size: px-em(32px);
			padding: px-em(38px) 0 px-em(38px) 0;
		}
	}
</style>



// WEBPACK FOOTER //
// SubIboxTitle.vue?1cbd6174